import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateZone } from 'src/features/zone/api/useCreateZone';
import { LIST_ZONES_RESOURCE } from 'src/features/zone/api/useListZones';
import ZoneFormModal from 'src/features/zone/components/form/ZoneFormModal';
import { Zone } from 'src/features/zone/utils/types';
import { zoneMessages } from 'src/features/zone/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface ZoneFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedZone?: Zone;
    children?: React.ReactNode;
}

function CreateZoneFormModal<TData>({ className, semantics }: ZoneFormModalProps<TData>) {
    const { formatMessage, locale } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateZone({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ZONES_RESOURCE] });
            toast({
                title: formatMessage(zoneMessages.createZoneSuccess),
                description: formatMessage(zoneMessages.createZoneSuccessDescription, {
                    entry: success.translations.find((translation) => translation.language === locale)?.name,
                }),
            });
        },
    });

    return (
        <ZoneFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(zoneMessages.addZoneSubtitle)}
        />
    );
}

export default CreateZoneFormModal;
